"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentModeInferenceReportEntrySchema = void 0;
const zod_1 = require("zod");
const ModeBase_1 = require("../DesignModels/ModeBase");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
exports.ComponentModeInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('model')
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil')),
    mode: ModeBase_1.ModeBaseSchema,
});
//# sourceMappingURL=ComponentModeInferenceReportEntry.js.map